import { render, staticRenderFns } from "./TagSetModal.vue?vue&type=template&id=22cbfd14&scoped=true"
import script from "./TagSetModal.vue?vue&type=script&lang=js"
export * from "./TagSetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbfd14",
  null
  
)

export default component.exports